import React from 'react';
import { SEOTableColumn, TableConfig } from 'src/api/models/SEOTable';
import Paragraph from 'src/elements/typography/paragraph';
import { Checkmark, CrossMark, UnCheckmark } from 'src/images/Checkmark';
import { setColor } from 'src/styles/colors';
import { BaseCellEntry, IconOnly, TextOnly } from './CellEntry.styles';
import AnchorToController from './AnchorToController';

type CellEntryProps = SEOTableColumn & TableConfig;

const CellEntry = ({ checked, text, checkIconSet, textColor, anchorTo }: CellEntryProps): JSX.Element => {
  const checkedIcon = (() => {
    const hasCheckedIcon = typeof checked === 'boolean';
    if (!hasCheckedIcon) {
      return null;
    }

    if (checkIconSet === 'check-unckeck') {
      return checked ? <Checkmark color={'pricingLightGreen'} /> : <CrossMark color={'pricingLightRed'} />;
    } else {
      return checked ? <Checkmark color={'pricingLightGreen'} /> : <UnCheckmark />;
    }
  })();

  const textParagraph = text && (
    <AnchorToController anchorTo={anchorTo}>
      <Paragraph
        text={text}
        align='left'
        standardSize='1'
        sizeSm='0.75rem'
        weight={500}
        color={setColor(textColor)}
      />
    </AnchorToController>
  );

  // Only icon is centered in Cell
  if (!text && checkedIcon) {
    return <IconOnly>{checkedIcon}</IconOnly>;
  }

  if (!!text && !checkedIcon) {
    return <TextOnly>{textParagraph}</TextOnly>;
  }

  // Standard Icon and Text
  return (
    <BaseCellEntry>
      {checkedIcon}
      {textParagraph}
    </BaseCellEntry>
  );
};

export default CellEntry;
